import { Grid, Paper, Typography, SvgIcon } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PostAddOutlined as PostAddOutlinedIcon, MedicationOutlined as MedicationOutlinedIcon } from "@mui/icons-material";

const itemsHome = [
  {
    title: "Recetas",
    to: "/prescriptions/new",
    description: "Desde aqui vas a poder generar una nueva prescripción o duplicado.",
    icon: <MedicationOutlinedIcon />,
    img: "/bg-recetas.png",
  },

  {
    title: "Ordenes",
    to: "/orders/new",
    description: "Desde aqui vas a poder generar una nueva orden, licencia o certificado médico.",
    icon: <PostAddOutlinedIcon />,
    img: "/bg-ordenes.png",
  },
];

export default function NewOrderAndNewPrescription() {
  const navigator = useNavigate();

  return (
    <Grid container spacing={5}>
      {itemsHome.map(({ img, icon, to, title, description }) => (
        <Grid item xs={12} sm={12} md={6} lg={6} xl={5} key={title}>
          <Paper
            onClick={() => navigator(to)}
            sx={{
              cursor: "pointer",
              height: "220px",
              borderRadius: 5,
              p: 4,
              color: "#FFFFFF",
              backgroundImage: `url(${img})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              "&:hover": { boxShadow: 1, backgroundImage: `linear-gradient(#00000010, #00000010), url(${img})` },
            }}
          >
            <Grid item xs={12} sm={12} md={12} lg={8}>
              <SvgIcon color="white" sx={{ fontSize: 40, ml: -1 }}>
                {icon}
              </SvgIcon>
              <Typography color="white" sx={{ fontSize: "28px", fontWeight: 600, mt: 1 }}>
                {title}
              </Typography>
              <Typography color="white" sx={{ fontSize: "16px", mt: 1 }}>
                {description}
              </Typography>
            </Grid>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}

